(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/utils/dialog-listener.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/utils/dialog-listener.js');

'use strict';

const {
  POST_MESSAGE_TYPES
} = svs.iam_idp.constants;
const PARENT_MESSAGE_SOURCE = 'svs-iam-parent';
function setupDialogListener(LoginInstance) {
  var _svs, _svs2, _svs3;
  const TRUSTED_ORIGINS = [window.location.origin, (_svs = svs) === null || _svs === void 0 || (_svs = _svs.iam_idp) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.origins) === null || _svs === void 0 ? void 0 : _svs.trusted, (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.iam_idp) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.origins) === null || _svs2 === void 0 ? void 0 : _svs2.target, (_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.iam_idp) === null || _svs3 === void 0 || (_svs3 = _svs3.data) === null || _svs3 === void 0 || (_svs3 = _svs3.origins) === null || _svs3 === void 0 ? void 0 : _svs3.sameSiteTarget].filter(Boolean);
  window.addEventListener('message', async event => {
    var _event$data, _event$data2, _event$data3;
    if (!TRUSTED_ORIGINS.includes(event.origin)) {
      return;
    }

    if ((event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.source) !== PARENT_MESSAGE_SOURCE) {
      return;
    }

    const messageType = ((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.messageType) || ((_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.type);
    if (messageType === POST_MESSAGE_TYPES.SHOW_DIALOG_RESOLVED) {
      if (LoginInstance.isDesktop) {
        LoginInstance.start(LoginInstance.isFreja, LoginInstance.isNewCustomer);
      }
    }
  });
}
svs.iam_idp.utils.setupDialogListener = setupDialogListener;

 })(window);